<template>
  <div>
    <div class="video-layout">
      <!-- 主持人 -->
      <share-player
        :class="activeVideo == 2 ? 'active' : ''"
        :cdbm="cdbm"
        v-if="showShare"
      />
      <div
        id="f_ocx"
        v-show="activeVideo == 1"
        :class="activeVideo == 1 ? 'active' : ''"
      >
        <video
          id="videoSxt"
          controls
          autoplay
          class="video-js vjs-default-skin"
          preload="auto"
          width="458px"
          height="270px"
          muted
          data-setup="{}"
        ></video>
      </div>
    </div>
    <!-- <div class="videoBtns">
      <el-row :gutter="10">
        <el-col :span="btnsSpan" v-for="(item, index) in btns" :key="index">
          <button
            :class="activeBtn == index ? 'active' : ''"
            type="button"
            @click="changeVideo(item.url, index)"
          >
            {{ item.text }}
          </button>
        </el-col>
      </el-row>
    </div> -->
  </div>
</template>
<script>
import videojs from "video.js";
import sharePlayer from "./sharePlayer.vue";
export default {
  name: "myVideo",
  components: {
    sharePlayer,
  },
  computed: {
    btnsSpan() {
      let s = 24;
      if (this.btns.length) {
        switch (this.btns.length) {
          case 1:
            s = 24;
            break;
          case 2:
            s = 12;
            break;
          case 3:
            s = 8;
            break;
          case 4:
            s = 6;
            break;
        }
      }
      return s;
    },
    showShare() {
      return this.cdbm;
    },
  },
  data() {
    return {
      btns: [],
      activeBtn: 0,
      cdbm: "", //
      player: null,
      activeVideo: 2,
      inTXY: false,
      // bdId: "",
    };
  },
  created() {
    window.addEventListener("message", this.handleMessage, false);
  },
  methods: {
    handleBeforeUnload(event) {
      const message = "您有未保存的更改，确定离开吗？";
      event.returnValue = message; // 标准方式
      return message; // 旧版浏览器兼容性
    },
    handleMessage(event) {
      if (event.data.isStartShare) {
        this.inTXY = true;
        this.getSxt(true);
        let obj = {
          lx: "sxtTbr",
          data: {
            id: "",
          },
        };
        this.$emit("send", JSON.stringify(obj));
      } else {
        this.inTXY = false;
        videojs.players["videoSxt"].dispose();
      }
    },
    changeVideo(url, index) {
      if (index == 0) {
        this.activeVideo = 2;
      } else {
        this.activeVideo = 1;
      }
      this.player.src([
        {
          type: "application/x-mpegURL",
          src: url,
        },
      ]);
      this.player.load();
      setTimeout(() => {
        const videoElement = this.$el.querySelector("#video_html5_api");
        const src = videoElement.src;
        if (src == "") {
          let url = window.location.href;
          let newUrl = "";
          if (this.$route.query.newParam) {
            url = url.replace(
              `newParam=${this.$route.query.newParam}`,
              `newParam=${index}`
            );
          } else {
            const separator = url.indexOf("?") > -1 ? "&" : "?";
            newUrl = url + separator + `newParam=${index}`;
          }
          window.location.href = newUrl;
        }
      }, 1000);

      this.activeBtn = index;
    },
    //获取摄像头参数
    getSxt(bool) {
      this.btns = [];
      this.$api
        .getSxtAndLive(this.bdId)
        .then((res) => {
          if (res.data.success) {
            var src = window.btoa(res.data.data.zcrBfdz);
            if (!src || res.data.data.zcrBfdz == null) {
            } else {
              this.cdbm = "https://ztxrtc.zhaotx.cn/tcPlayer?streamName=" + src;
            }
            if (res.data.data.sxtInfo.sxtdz) {
              let sxtdz = res.data.data.sxtdz.split(",");
              if (bool) {
                var player = videojs("videoSxt");
                player.src({
                  src: sxtdz[0],
                  type: "video/mp4",
                });
                player.play();
              } else {
                this.getVideo(sxtdz[0]);
              }
            }
          }
        })
        .catch(() => {});
    },
    getVideo(src) {
      this.activeVideo = 2;
      this.player = videojs("videoSxt", {
        bigPlayButton: false,
        textTrackDisplay: false,
        posterImage: true,
        errorDisplay: false,
        controlBar: true,
        preload: "auto",
        autoplay: true,
        controls: true,
        sources: [
          {
            src: src,
            type: "application/x-mpegURL",
          },
        ],
      });
    },
  },
  props: {
    bdId: {
      type: String,
      default: "",
    },
  },
  mounted() {
    // this.bdId = this.$route.query.bdId;
    this.getSxt();
  },
  destroyed() {
    if (this.player) {
      this.player.dispose();
    }
  },
};
</script>
<style lang="less">
.iframe {
  width: 100%;
  height: 100%;
}
.video-dimensions {
  overflow: hidden;
  width: 100% !important;
  height: 100% !important;
  video {
    width: 100%;
    height: 100%;
  }
}
.video {
  width: 100%;
  height: 100%;
  background: #333;
  position: relative;
  #f_ocx {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    visibility: hidden;
    background: #333;
  }
  #f_ocx.active {
    visibility: initial;
  }
  #f_ocx2 {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #333;
    //visibility: hidden;
  }
  #f_ocx2.active {
    visibility: initial;
  }
}
.videoBtns {
  width: 95%;
  padding: 10px 0;
  margin: 0 auto;
  button {
    height: 45px;
    line-height: 45px;
    background: #404040;
    color: #fff;
    font-size: 16px;
    width: 100%;
  }
  button.active {
    background: @base-color;
    font-weight: bold;
  }
}
</style>